import {
  ExclamationCircleOutlined,
  FileTextOutlined,
  ProjectOutlined,
  TeamOutlined
} from "@ant-design/icons"
import React from "react"

import { RoutesPaths } from "../../../../constants/routes.ts"
import { LEAD_STATUSES } from "../../../Lead/constants/lead-statuses.ts"
import { type PermissionFeatures } from "../../../SettingsPermissions/types/permissions.types.ts"
import type { DashboardStats as DashboardStatsType } from "../../types/types.ts"

export type DashboardStatType = "projects" | "checklists" | "invoices" | "leads"

export interface DashboardStatItemConfig {
  key: DashboardStatType
  icon: React.ReactNode
  iconBg: string
  iconColor: string
  title: string
  metric: keyof DashboardStatsType
  format: (value: number) => string
  href?: string
  isVisible: (permissionFeatures: PermissionFeatures) => boolean
}

export const readStatValue = (
  data: DashboardStatsType | null,
  stat: DashboardStatItemConfig
): string | null => {
  const value = data?.[stat.metric]
  return typeof value === "number" ? stat.format(value) : null
}

const DASHBOARD_STATS_ITEMS: DashboardStatItemConfig[] = [
  {
    key: "projects",
    icon: <ProjectOutlined style={{ fontSize: 20 }} />,
    iconBg: "#e6f4ff",
    iconColor: "#1677ff",
    title: "Projects",
    metric: "active_projects",
    format: (value) => `${value} Active`,
    href: RoutesPaths.project.grid,
    isVisible: (codes) => !!codes?.projects?.projects?.project_view
  },
  {
    key: "checklists",
    icon: <FileTextOutlined style={{ fontSize: 20 }} />,
    iconBg: "#fffbe6",
    iconColor: "#faad14",
    title: "Checklists items",
    metric: "pending_checklists",
    format: (value) => `${value} pending`,
    isVisible: (codes) => !!codes?.projects?.checklists?.project_checklist_view
  },
  {
    key: "invoices",
    icon: <ExclamationCircleOutlined style={{ fontSize: 20 }} />,
    iconBg: "#fff2f0",
    iconColor: "#ff4d4f",
    title: "Overdue Invoices",
    metric: "overdue_invoices",
    format: (value) => `${value} Invoices`,
    isVisible: (codes) => !!codes?.projects?.invoices?.project_invoice_view
  },
  {
    key: "leads",
    icon: <TeamOutlined style={{ fontSize: 20 }} />,
    iconBg: "#e6f4ff",
    iconColor: "#1677ff",
    title: "Leads",
    metric: "new_leads",
    format: (value) => `${value} New Leads`,
    href: `${RoutesPaths.lead.list}?status=${LEAD_STATUSES.NEW}`,
    isVisible: (codes) => !!codes?.leads?.leads?.lead_view
  }
]

export { DASHBOARD_STATS_ITEMS }
